<div class="global-tracking">
    <div class="global-tracking__body">
        <app-map-tracking class="global-tracking__map" [cargos]="cargos" [cargoSelected]="cargoSelected" (loadingMap)="loadingMap = $event">
        </app-map-tracking>
        <app-global-tracking-list class="global-tracking__list" [cargos]="cargos" [cargoSelected]="cargoSelected"
            [loadingCargos]="loadingCargos" [loadingMap]="loadingMap"
            (onSelectCargo)="onSelectCargo($event)" (onFilterChanges)="refreshList($event)">
        </app-global-tracking-list>
    </div>
</div>
